import { styled, theme } from "../theme";
export const TooltipWrapper = styled.div `
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const TooltipContent = styled.div `
  position: fixed;
  background: ${theme.color.gray150};
  color: ${theme.color.white};
  padding: 8px 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1100;
  pointer-events: none;
  font-size: ${theme.fontSize[1]};
`;
export const TooltipArrow = styled.div `
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent;

  &[data-placement^="top"] {
    bottom: -6px;
    border-width: 6px 6px 0 6px;
    border-top-color: ${theme.color.gray150};
  }

  &[data-placement^="bottom"] {
    top: -6px;
    border-width: 0 6px 6px 6px;
    border-bottom-color: ${theme.color.gray150};
  }

  &[data-placement^="right"] {
    left: -6px;
    border-width: 6px 6px 6px 0;
    border-right-color: ${theme.color.gray150};
  }

  &[data-placement^="left"] {
    right: -6px;
    border-width: 6px 0 6px 6px;
    border-left-color: ${theme.color.gray150};
  }
`;
